export default {
  methods: {
    formatDateTime(value) {
      if (!value) return 'N/A'
      return new Date(value).toLocaleString()
    },
    formatDateRange(start, finish) {
      if (!start) return 'N/A'
      const fmt = (v) => new Date(v).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
      const s = fmt(start)
      const f = finish ? fmt(finish) : null
      return f && f !== s ? `${s} – ${f}` : s
    },
    driverInitials(name) {
      if (!name) return '?'
      return name.split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase()
    },
    paymentClass(status) {
      if (!status) return ''
      const s = status.toLowerCase()
      if (s.includes('paid in full') || s.includes('paid')) return 'payment-paid'
      if (s.includes('balance') || s.includes('due') || s.includes('outstanding')) return 'payment-due'
      if (s.includes('deposit') || s.includes('pending')) return 'payment-deposit'
      return 'payment-other'
    },
  },
}
